import React from 'react';
import pkg from "@inrscr/coschool-ui-components";
import styles from '../pages/privacy/privacy.module.css';
import mobile from '../pages/privacy/assets/mobile.svg';
import location from '../pages/privacy/assets/location.svg';
import mail from '../pages/privacy/assets/email.svg';
import contactCard from '../pages/privacy/assets/contact.svg';
import { useRoot } from '../context/RootContext';

export let loader = async () => {
  return { type: "privacy" };
};


export default function PrivacyPage() {
  const { isAuthenticated } = useRoot();
  const { PrivacyPolicy } = pkg;
  return (
    <PrivacyPolicy
      showHeader={isAuthenticated}
      styles={styles}
      assets={{ mobile, location, mail, contactCard }}
      isStudent={true} />);


}